import { object, string } from 'yup';

import { getMaxLengthErrMsg, getMinLengthErrMsg } from '@constants/validationConstants';
import { MAX_2_LENGTH, MAX_60_LENGTH } from '@constants/validationMessages';

export const assetSubTypeSchema = (handleCheckName: (name: string) => void) => object({
	assetSubTypeName: string()
		.trim()
		.nullable()
		.min(MAX_2_LENGTH, getMinLengthErrMsg('Asset subtype name', MAX_2_LENGTH))
		.max(MAX_60_LENGTH, getMaxLengthErrMsg('Asset subtype name', MAX_60_LENGTH))
		.test('assetSubTypeName', 'Asset subtype name must be unique',
			async (value) => {
				if (!value) return false;

				try {
					await handleCheckName(value);

					return true;
				} catch (err) {
					return false;
				}
			},
		),
});
